import { ActionType } from '../action-types';
import { Action } from '../actions/Action';
import _, { sortBy } from 'lodash';
import initialState from './init/dashboardInitialState';


const dashboardReducer = (state = initialState, action: Action) => {
	let updatedSystem = null;
	let updatedSystems = [];
	let updatedNodes = [];
	let newLogs = [];
	let isRecalculatedData = {};
	let system;
	let currentSystem;
	let account;
	let sortBy = 'date';
	let filtersChanged = false;
	let newInspections = [];
	let newAgreements = [];
	let newServiceActions = [];
	let newInspectionServiceActions = [];
	let newSimcards = [];
	let newRouters = [];
	let newSmses = {data: [], totalRecords: 0};	
	let newSystemGroups = [];
	let newSystemsForGroup = [];
	let newSystems = [];
	let newNodeImages = [];
	const sortDict = {
		'system_name': 'systemName',
		'id': 'logID',
		'event_timestamp': 'eventTimestamp',
		'severity': 'severity'
	};
	let logFilters = state.logFilters ?? {
		'systemId': null,
		'nodeId': null,
		'searchedText': null,
		'dateStart': null,
		'dateEnd': null,
		'sortBy': 'eventTimestamp',
		'sortOrder': 'DESC'
	};
	switch (action.type) {
		case ActionType.EDITING_TOGGLE:
			return {
				...state,
				isEditing: action.payload ? action.payload : !state.isEditing,
			};
		case ActionType.POLYGON_SAVE_SUCCESS:
			let mapBoundaries = '(' + action.mapBoundaries.join(';') + ')';
			system = state.system;
            if (system.ID === action.systemId) {
                system['mapObjectsBoundaries'] = mapBoundaries;
                system['updatedViaWebsiteAt'] = action.updatedViaWebsiteAt;
            }
			return {
				...state,
				system: system,
// 				systemUpdatedViaWebsiteAt: action.updatedViaWebsiteAt
			};
		case ActionType.SAVE_POINTS_SUCCESSFULLY:
			_.forEach(state.nodes, (node) => {
				if (node.id === action.nodeId) {
					node['updatedViaWebsiteAt'] = action.updatedViaWebsiteAt;
				}
				updatedNodes.push(node);
			});
			return {
				...state,
				nodes: updatedNodes,
			};
		case ActionType.MAP_UPLOAD_SUCCESS:
		    currentSystem = state.system;
		    currentSystem['updatedViaWebsiteAt'] = action.updatedViaWebsiteAt;
			_.forEach(state.systems, (sys) => {
				if (sys.ID === action.systemId) {
					sys['updatedViaWebsiteAt'] = action.updatedViaWebsiteAt;
				}
				updatedSystems.push(sys);
			});
			return {
				...state,
				systems: updatedSystems,
				FreeSystems: updatedSystems,
				system: currentSystem,
			};
		case ActionType.FETCH_ERROR:
			// let is = initialState;
			// is.error = action.error;
			// return is;
			return state;
		case ActionType.SHOW_LOADING:
			return {
				...state,
				isLoading: action.isLoading,
			};
		case ActionType.MEASUREMENTS_LOADING:
			return {
				...state,
				measurementsLoading: action.measurementsLoading,
			};
		case ActionType.GET_SYSTEM_MAP: 
			let md = action.systemMapData;
			return {
				...state,
				systemMapDataBlob: action.systemMapDataBlob,
				isMapLoading: action.isMapLoading,
				mainMapWidth: action.mainMapWidth,
    			mainMapHeight: action.mainMapHeight,
			};
		case ActionType.GET_ALT_MAPS: 
			return {
				...state,
				systemSecondMapDataBlob: action.systemSecondMapDataBlob,
				systemThirdMapDataBlob: action.systemThirdMapDataBlob,
			};
		case ActionType.DELETE_MAP_SUCCEEDED:
			if (action.mapType == 'second') {
				return {
					...state,
					systemSecondMapDataBlob: null,
				}
			}
			return {
				...state,
				systemThirdMapDataBlob: null,

			};
		case ActionType.CLEAR_DASHBOARD_DATA:
			return {
				...state,
				system: null,
				forbidden: false,
				nodes: [],
				isRecalculated: {},
				isEditing: false,
				isNodesLoading: true,
				isMapLoading: true,
				systemMapDataBlob: null,
				accelerateSucceeded: false,
				acceleratedNodes: true,
				systemFiles: [],
				filesAccounts: [],
				dashboardFilteredSystemNamesForGroup: []
			};
		case ActionType.GET_SYSTEM_FULL:
            if (action.systemData.ID === 0) {
                return {
                    ...state,
                    forbidden: true
                };
            }
			currentSystem = state.system;
			if (currentSystem && currentSystem.ID === action.systemID || !currentSystem) {
                let resultObj = action.systemData;
                return {
                    ...state,
                    system: resultObj,
                };
			}
			return {
			    ...state
			}
		case ActionType.GET_SYSTEMS:
			return {
				...state,
				systems: action.systems,
				FreeSystems: action.systems
			};
		case ActionType.FETCH_SYSTEMS:
		    let currentSystems = state.systems ?? [];
			return {
				...state,
				systems: [...currentSystems, ...action.fetchedSystems],
			};
        case ActionType.ARE_SYSTEMS_FETCHING:
			return {
				...state,
				areSystemsFetching: action.areSystemsFetching,
			};
		case ActionType.SET_NODES_LOADING:
			return {
				...state,
				isNodesLoading: true,
			};
		case ActionType.GET_NODES:
			return {
                ...state,
                isNodesLoading: false,
                nodes: action.nodes,
            };
		case ActionType.GET_NODE:
		    if (action.node?.id === 0) {
                return {
                    ...state,
                    forbidden: true
                };
		    }
			return {
                ...state,
                forbidden: false,
                node: action.node,
                isNodeLoading: false
            };
		case ActionType.CLEAR_NODE:
			return {
                ...state,
                node: undefined,
                isNodeLoading: true,
                measurementsPage: 0,
                measurementsRange: 30,
                forbidden: false
            };
		case ActionType.LOGS_LOADING:
			return {
				...state,
				isLogsLoading: true,
			};
		case ActionType.CLEAR_LOGS:
			return {
				...state,
				logs: null,
			};
        case ActionType.GET_SYSTEMS_NODES_SHORT:
 			return {
				...state,
				systemsNodesShort: action.systemsNodesShort,
			};
		case ActionType.GET_SYSTEMS_NODES_ROUTERS_SHORT:
 			return {
				...state,
				systemsNodesRoutersShort: action.systemsNodesRoutersShort,
			};
		case ActionType.GET_LOGS:
			console.log('GET_LOGS');
			sortBy = action.sortBy ? sortDict[action.sortBy] : 'eventTimestamp';
			filtersChanged = logFilters['systemId'] != action.systemID || 
							 logFilters['nodeId'] != action.nodeID || 
							 logFilters['searchedText'] != action.searchedText ||
							 logFilters['dateStart'] != action.dateStart ||
							 logFilters['dateEnd'] != action.dateEnd ||
							 logFilters['sortBy'] != sortBy ||
							 logFilters['sortOrder'] != action.sortOrder;	
			if (!state.logs || filtersChanged) {
				newLogs = action.logs;
			} else {
				if (logFilters['sortOrder'] == 'ASC') {
					newLogs = _.sortBy(_.unionBy([...state.logs], [...action.logs], 'id'), [sortBy]);
				} else {
					newLogs = _.reverse(_.sortBy(_.unionBy([...state.logs], [...action.logs], 'id'), [sortBy]));
				}
			}
			logFilters['systemId'] = action.systemID;
			logFilters['nodeId'] = action.nodeID;
			logFilters['searchedText'] = action.searchedText;
			logFilters['dateStart'] = action.dateStart;
			logFilters['dateEnd'] = action.dateEnd;
			logFilters['sortBy'] =  sortBy;
			logFilters['sortOrder'] = action.sortOrder;	
			return {
				...state,
				logs: newLogs,
				logFilters: logFilters,
				isLogsLoading: false,
				logsCount: action.logsCount
			};
		case ActionType.NOTIFICATION_CONFIRMED:
			return {
				...state,
			};
		case ActionType.GET_MEASUREMENTS:
			return {
				...state,
				measurements: action.measurements,
				measurementsLoading: false,
			};
		case ActionType.GET_MY_ROLE:
			return {
				...state,
				myRole: action.myRole,
			};
		case ActionType.ACCOUNTS_LOADING:
			return {
				...state,
				isAccountsLoading: true,
			};
		case ActionType.ACCOUNTS_LOADED:
			return {
				...state,
				isAccountsLoading: false,
			};
		case ActionType.GET_VISIBLE_ACCOUNTS:
			return {
				...state,
				accounts: action.accounts,
			};
		case ActionType.GET_ACCOUNT:
		    let forbidden = false;
		    if (action.account.id === 0) {
		        forbidden = true;
		    }
			return {
				...state,
				account: action.account,
				forbidden: forbidden
			};
		case ActionType.TOGGLE_NOTIFICATION_POPPER: {
			return {
				...state,
				notificationPopperOpen: !state.notificationPopperOpen,
			};
		}
		case ActionType.TOGGLE_LOGOUT_POPPER: {
			return {
				...state,
				logoutPopperOpen: !state.logoutPopperOpen,
			};
		}
		case ActionType.GOTO_LOGS: {
			return {
				...state,
				gotoLogs: state.gotoLogs,
			};
		}

		case ActionType.TOGGLE_CHART_TYPE: {
			return {
				...state,
				showChartThreshold: !state.showChartThreshold,
			};
		}

		case ActionType.EXPORT_START: {
			let disabledIcons;
			if (state.disabledDownloadIcons.length === 0) {
				disabledIcons = [action.payload];
			} else {
				disabledIcons = [...state.disabledDownloadIcons, action.payload];
			}
			return {
				...state,
				isFileExporting: true,
				disabledDownloadIcons: disabledIcons,
			};
		}

		case ActionType.EXPORT_STOP: {
			const disabledIcons = state.disabledDownloadIcons.filter(
				(element) => element !== action.payload
			);
			return {
				...state,
				isFileExporting: false,
				disabledDownloadIcons: disabledIcons,
			};
		}

		case ActionType.SET_CURRENT_NODE_ID:
			return {
				...state,
				previousNodeId: state.currentNodeId,
				currentNodeId: action.currentNodeId,
			};

		case ActionType.FILTER_SYSTEMS:
			return {
				...state,
				filteredSystemId: action.filteredSystemId,
			};

		case ActionType.VALIDATION_SUCCESS:
			if (action.updated === 'Succeeded') {
				account = _.filter(state.accounts, {
					id: action.account.about.id,
				})[0];
				let currentAccount = state.account;
				currentAccount.updatedAt = action.account.updatedAt.Time;
				account.updatedAt = action.account.updatedAt.Time;
				let accounts = _.remove(state.accounts, (a) => {
					return a.id === action.account.id;
				});
				let accNew = accounts.push(account);
				return {
					...state,
					accounts: accNew,
					account: currentAccount,
				};
			}
			return {
				...state,
			};
		case ActionType.EDIT_ACCOUNT_SUCCESS:
		    if (state.account) {
		        account = state.account;
                account.id = action.account.accountID;
                account.updatedAt = action.account.updatedAt;
                account.email = action.account.email;
                account.name = action.account.name;
                account.phone.String = action.account.phone;
                account.language = action.account.language;
                account.timezone = action.account.timezone;
                return {
                    ...state,
                    account: account,
                };
		    }
			account = _.filter(state.accounts, {
				id: action.account.accountID,
			})[0];
			account.id = action.account.accountID;
			account.updatedAt = action.account.updatedAt;
			account.email = action.account.email;
			account.name = action.account.name;
			account.phone.String = action.account.phone;
			account.language = action.account.language;
			account.timezone = action.account.timezone;
			let tmpAccounts = _.filter(state.accounts, (account) => {
				return account.id !== action.account.accountID;
			});
			tmpAccounts.push(account);
			return {
				...state,
				accounts: tmpAccounts,
			};
		case ActionType.LOGOUT:
			// clear state
			return initialState;
		case ActionType.LOGIN_SUCCESS:
			// clear state left by another account (logged in on this browser without logging out); keep the screen size
			return { ...initialState, mobileView: state.mobileView };

		//Admin:
		case ActionType.SETTING_NEW_NODE_NAME_SUCCESS:
			_.forEach(state.nodes, (node) => {
				if (node.id === action.id) {
					node.name = action.name;
					node.updatedViaWebsiteAt = action.updatedAt;
				}
				updatedNodes.push(node);
			});
			return {
				...state,
				nodes: updatedNodes,
				isEditing: false,
				settingNewNodeNameSuccess: true,
				settingNewNodeNameFailed: false,
			};
		case ActionType.SETTING_NEW_NODE_NAME_FAILED:
			return {
				...state,
				settingNewNodeNameSuccess: false,
				settingNewNodeNameFailed: true,
			};
		case ActionType.CLOSE_SETTING_NEW_NODE_NAME_CARD:
			return {
				...state,
				settingNewNodeNameSuccess: false,
				settingNewNodeNameFailed: false,
			};
		//Installer
		case ActionType.CREATE_SYSTEM:
			return {
				...state,
				NewSystemID: action.payload.NewSystemID,
			};
		case ActionType.TOGGLE_REFRESH_BUTTON:
			return {
				...state,
				disableRefreshButton: !state.disableRefreshButton,
			};
		case ActionType.TOGGLE_CREATE_NODE_BUTTON:
			return {
				...state,
				disableCreateNodeButton: !state.disableCreateNodeButton,
			};
		case ActionType.GET_FREE_DEVICES:
			return {
				...state,
				FreeDevices: _.sortBy(action.FreeDevices, (dev) => dev.SerialString),
			};
		case ActionType.GET_DEVICES:
			return {
				...state,
				devices: action.devices,
			};
		case ActionType.GET_GATEWAYS:
			return {
				...state,
				gateways: action.gateways,
			};
		case ActionType.GET_SYSTEMS_MAPS_INFO:
			return {
				...state,
				systemsMapsInfo: action.systemsMapsInfo,
			};
		case ActionType.CREATE_NODE: {
			const { payload } = action;
			const fd = state.FreeDevices.filter((d) => d.SerialString !== payload.DeviceSerialString);
			const nn = [...state.NewNodes, payload];
			return {
				...state,
				NewNodes: nn,
				FreeDevices: fd,
			};
		}
		case ActionType.DISABLE_SYSTEM_SUBMIT:
			return {
				...state,
				disableSystemSubmit: !state.disableSystemSubmit,
			};
		case ActionType.DISABLE_NODE_SUBMIT:
			return {
				...state,
				disableNodeSubmit: !state.disableNodeSubmit,
			};

		case ActionType.CREATE_NODE_SUCCESS:
			return {
				...state,
				createNodeFail: false,
				createNodeSuccess: true,
			};
		case ActionType.CREATE_NODE_FAIL:
			return {
				...state,
				createNodeFail: true,
				createNodeSuccess: false,
			};
		case ActionType.CLOSE_CREATE_NODE_NOTIFICATION:
			return {
				...state,
				createNodeFail: false,
				createNodeSuccess: false,
			};
		case ActionType.CLOSE_CREATE_ACCOUNT_NOTIFICATION:
			return {
				...state,
				createAccountSucceeded: false,
				createAccountFailed: false,
			};
        case ActionType.CLOSE_NODE_RECALCULATED_NOTIFICATION:
            isRecalculatedData = state.isRecalculated;
            delete isRecalculatedData[action.nodeName];
            return {
                ...state,
                isRecalculated: {...isRecalculatedData}
            }
        case ActionType.CLOSE_NODE_WILL_RECALCULATE_NOTIFICATION:
            isRecalculatedData = state.isRecalculated;
            delete isRecalculatedData[action.nodeName];
            return {
                ...state,
                isRecalculated: {...isRecalculatedData}
            }
        case ActionType.CLOSE_NODE_ACCELERATED_NOTIFICATION:
            return {
                ...state,
                accelerateSucceeded: false
            }
		case ActionType.CLOSE_ACCELERATED_NODES_NOTIFICATION:
			return {
				...state,
				acceleratedNodes: false
			}
		case ActionType.CREATE_ACCOUNT_SUCCEEDED:
			return {
				...state,
				createAccountSucceeded: true,
				createAccountFailed: false,
				accounts: [...state.accounts, {
					id: action.newId,
					name: action.name,
					email: action.email,
					accountCategory: 'commoner'
				}]
			};
		case ActionType.CREATE_ACCOUNT_FAILED:
			return {
				...state,
				createAccountSucceeded: false,
				createAccountFailed: true,
			};
		case ActionType.PIN_ACCOUNT_SUCCEEDED:
			return {
				...state,
				pinAccountSucceeded: true,
				pinAccountFailed: false,
			};
		case ActionType.PIN_ACCOUNT_FAILED:
			return {
				...state,
				pinAccountSucceeded: false,
				pinAccountFailed: true,
			};
		case ActionType.CLOSE_PIN_ACCOUNT_NOTIFICATION:
			return {
				...state,
				pinAccountSucceeded: false,
				pinAccountFailed: false,
			};
		case ActionType.GET_FREE_SYSTEMS:
			return {
				...state,
				FreeSystems: action.FreeSystems,
			};
		case ActionType.DISABLE_CREATE_ACCOUNT_SUBMIT:
			return {
				...state,
				disableCreateAccountButton: !state.disableCreateAccountButton,
			};
		case ActionType.GET_VISIBLE_SYSTEMS_FOR_ACCOUNT:
			const { accountID, systemsDetails } = action;
			let newAccounts = [...state.accounts] ?? [];
			newAccounts.forEach((acc) => {
				if (acc.id === accountID) {
					acc['systemsDetails'] = systemsDetails;
				}
			});
            let newAccount = state.account;
			if (newAccount) {
				newAccount['systemsDetails'] = systemsDetails;
			}
			
			return {
				...state,
				accounts: newAccounts,
				account: newAccount,
			};
		case ActionType.SHOW_NO_MEASUREMENTS_WARNING: {
			let warnings = [];
			if (state.noMeasurementsWarnings.length === 0) {
				warnings = [action.payload];
			} else {
				warnings = [...state.noMeasurementsWarnings, action.payload];
			}
			return {
				...state,
				noMeasurementsWarnings: warnings,
			};
		}
		case ActionType.CLOSE_NO_MEASUREMENTS_WARNING: {
			const warnings = state.noMeasurementsWarnings.filter(
				(element) => element !== action.payload
			);
			return {
				...state,
				noMeasurementsWarnings: warnings,
			};
		}
		case ActionType.SET_MOBILE_VIEW: {
			return {
				...state,
				mobileView: action.mobileView,
			};
		}
		case ActionType.SET_DESKTOP_VIEW: {
			return {
				...state,
				mobileView: action.mobileView,
			};
		}

		case ActionType.ACCEPT_PUSH_NOTIFICATIONS: {
			const result = [...state.accountsWithPushNotificationsApproval, action.payload];
			return {
				...state,
				accountsWithPushNotificationsApproval: result,
			};
		}

		case ActionType.REJECT_PUSH_NOTIFICATIONS: {
			const result = state.accountsWithPushNotificationsApproval.filter(
				(currentId) => currentId !== action.payload
			);
			return {
				...state,
				accountsWithPushNotificationsApproval: result,
			};
		}

		case ActionType.NOTIFICATION_SETTINGS_UPDATE: {
			return {
				...state,
				notificationSettingsUpdatedSuccessfully: true,
				notificationSettingsUpdatedFailed: false,
				updatedSystemNotificationId: action.systemID,
			};
		}

		case ActionType.NOTIFICATION_SETTINGS_UPDATE_FAILED: {
			return {
				...state,
				notificationSettingsUpdatedSuccessfully: false,
				notificationSettingsUpdatedFailed: true,
			};
		}

		case ActionType.CLOSE_NOTIFICATION_SETTINGS_UPDATE: {
			return {
				...state,
				notificationSettingsUpdatedSuccessfully: false,
				notificationSettingsUpdatedFailed: false,
			};
		}

		case ActionType.SHOW_FILTERED_SYSTEMS: {
			return {
				...state,
				dashboardFilteredSystems: action.payload,
			};
		}
		case ActionType.SHOW_FILTERED_SYSTEMS_NAMES: {
			return {
				...state,
				dashboardFilteredSystemsNames: action.payload,
			};
		}
		case ActionType.SHOW_FILTERED_SYSTEM_GROUPS_NAMES: {
			return {
				...state,
				dashboardFilteredSystemGroupsNames: action.payload,
			};
		}
		case ActionType.SHOW_FILTERED_SYSTEM_GROUPS: {
			return {
				...state,
				dashboardFilteredSystemGroups: action.payload,
			};
		}
		case ActionType.SHOW_FILTERED_NODES_NAMES: {
			return {
				...state,
				dashboardFilteredNodesNames: action.payload,
			};
		}

		case ActionType.SHOW_FILTERED_NODES: {
			// remove duplicates using Set:
			const currentNodes = [...new Set(action.payload)];
			return {
				...state,
				dashboardFilteredNodes: currentNodes,
			};
		}

		case ActionType.UPDATE_PICKED_SYSTEM_NAME: {
			return {
				...state,
				isFilteredSystemNameUpdated: action.payload,
			};
		}

		case ActionType.SHOW_SYSTEM_SEARCH_BAR: {
			return {
				...state,
				isSystemSearchBarVisible: action.payload,
			};
		}
		case ActionType.SHOW_SYSTEM_GROUP_SEARCH_BAR: {
			return {
				...state,
				isSystemGroupSearchBarVisible: action.payload,
			};
		}
		case ActionType.UPDATE_PICKED_SYSTEM_GROUP_NAME: {
			return {
				...state,
				isFilteredSystemGroupNameUpdated: action.payload,
			};
		}

		case ActionType.BASE_NODE: { 
			const { payload } = action;
			const { NodeID, NewBaseAngle, NewBaseDistance } = payload;
			if (payload.UpdatedResult.succeeded) {
				_.forEach(state.nodes, (node) => {
					let clone = {};
					if (node.id === NodeID) {
						node.updatedViaWebsiteAt = payload.UpdatedResult.updatedAt;
						node.MeasurementBaseAngle = NewBaseAngle;
						node.MeasurementBaseDistance = NewBaseDistance;

						clone = Object.assign({}, node);
						updatedNodes.push(clone);
					} else {
						updatedNodes.push(node);
					}
				});
			}
			return {
				...state,
				nodes: updatedNodes,
			};
		}

		case ActionType.CONFIGURE_NODE: {
			const { payload } = action;
			const { UpdatedResult, NodeID, Threshold, L1, L2, L3, L4, InclinometerInverted, NewThreatLevel, NewObstructionStatus } = payload;
			if (UpdatedResult.succeeded) {
				_.forEach(state.nodes, (node) => {
					let clone = {};
					if (node.id === NodeID) {
						node.updatedViaWebsiteAt = UpdatedResult.updatedAt;
						node.PermissibleValue = Threshold;
						node.ThresholdLevel1 = L1;
						node.ThresholdLevel2 = L2;
						node.ThresholdLevel3 = L3;
						node.ThresholdLevel4 = L4;
						node.InclinometerInverted = InclinometerInverted;
						node.LatestKnownThreatLevel = NewThreatLevel;
						node.ObstructionStatus = NewObstructionStatus?.Int32;

						clone = Object.assign({}, node);
						updatedNodes.push(clone);
					} else {
						updatedNodes.push(node);
					}
				});
			}
			return {
				...state,
				nodes: updatedNodes,
			};
		}

		case ActionType.IS_NODE_RECALCULATED: {
		    isRecalculatedData = state.isRecalculated;
		    isRecalculatedData[action.nodeName] = action.isRecalculated;
			return {
				...state,
				isRecalculated: {...isRecalculatedData},
			};
		}
        case ActionType.ACCELERATE_NODE: {
            const { payload } = action;
			const { UpdatedResult, NodeID, NewAcceleratedUntil } = payload;
			if (UpdatedResult.succeeded) {
				_.forEach(state.nodes, (node) => {
					if (node.id === NodeID) {
						node.updatedViaWebsiteAt = UpdatedResult.updatedAt;
						node.AcceleratedUntil = NewAcceleratedUntil;
					}
                    updatedNodes.push(node);
				});
			}
			return {
				...state,
				nodes: updatedNodes,
				accelerateSucceeded: !!NodeID,
				nodeAcceleratedUntil: NewAcceleratedUntil,

			};
        }
		case ActionType.SET_NODE_ACTIVE: {
            const { payload } = action;
			const { UpdatedResult, NodeID, NewActive } = payload;
			if (UpdatedResult.succeeded) {
				_.forEach(state.nodes, (node) => {
					if (node.id === NodeID) {
						node.updatedViaWebsiteAt = UpdatedResult.updatedAt;
						node.active = NewActive;
					}
                    updatedNodes.push(node);
				});
			}
			return {
				...state,
				nodes: updatedNodes,
				settingNodeActiveSuccess: UpdatedResult.succeeded,
				settingNodeActiveFailed: !UpdatedResult.succeeded
			};
        }
		case ActionType.CONFIRMED_LOG: {
			newLogs = [];
			state.logs.forEach((log) => {
				if (log.id === action.logID) {
					log['confirmed'] = "true!";
				}
				newLogs.push(log);
			});
			return {
				...state,
				confirmedLogSuccessfully: true,
				confirmedLogFailed: false,
				logs: newLogs
			};
		}
		case ActionType.CONFIRMED_LOG_FAILED: {
			return {
				...state,
				confirmedLogSuccessfully: false,
				confirmedLogFailed: true,
			};
		}
		case ActionType.CONFIRMED_LOG_CLOSE_NOTIFICATION: {
			return {
				...state,
				confirmedLogSuccessfully: false,
				confirmedLogFailed: false,
			};
		}
		case ActionType.CLEAR_EDIT_ACCOUNT_STATE: {
			return {
				...state,
				account: null,
				forbidden: false,
				wasFetchedVisibleSystems: false,
				loggedUserId: null,
                accountLoaded: false,
				dashboardFilteredSystemsNames: [],
				dashboardFilteredSystems: [],
			};
		}
        case ActionType.UNREGISTER_FROM_MOBILE_APP:
            account = state.account;
            account.RegisteredInMobileApp = false;
            return {
                ...state,
                account: account
            }

		case ActionType.GET_SYSTEM_FILES:
			return {
				...state,
				systemFiles: action.systemFiles ?? [],
			};

		case ActionType.GET_SYSTEM_FILE:
			return {
				...state,
				systemFileDataBlob: action.systemFileDataBlob,
			};
		case ActionType.FILE_UPLOAD_SUCCESS:
			let systemFiles = [...state.systemFiles] ?? [];
			systemFiles.unshift(action.newFile);
			return {
				...state,
				systemFiles: systemFiles
			};
		case ActionType.FILE_DELETED:
			let newSystemFiles = [];
			_.forEach(state.systemFiles, (file) => {
				if (file.id !== action.fileId) {
					newSystemFiles.push(file);
				}
			});
			return {
				...state,
				systemFiles: newSystemFiles
			};
		case ActionType.GET_SYSTEM_FILE_ACCOUNTS:
			return {
				...state,
				filesAccounts: action.filesAccounts ?? [],
			};
		case ActionType.GET_INSPECTIONS:
			return {
				...state,
				inspections: action.inspections ?? []
			}
		case ActionType.UPDATE_INSPECTION_SUCCESS:
			newInspections = [];
			_.forEach([...state.inspections], (inspection) => {
				if (inspection.ID == action.inspection.ID) {
					inspection = action.inspection;
				}
				newInspections.push(inspection);
			});
			
			return {
				...state,
				inspections: newInspections,
				updateInspectionSuccess: true
			}
		case ActionType.UPDATE_INSPECTION_FAILED:
			return {
				...state,
				updateInspectionFail: true,
			}
		case ActionType.CLOSE_UPDATE_INSPECTION_SUCCESS_NOTIFICATION:
			return {
				...state,
				updateInspectionSuccess: false,
			}
		case ActionType.CLOSE_UPDATE_INSPECTION_FAIL_NOTIFICATION:
			return {
				...state,
				updateInspectionFail: false,
			}
		case ActionType.CREATE_INSPECTION_SUCCESS:
			newInspections = [...state.inspections];
			newInspections.push(action.inspection);
			return {
				...state,
				inspections: newInspections,
				lastCreatedInspection: action.inspection,
				createInspectionSuccess: true
			}
		case ActionType.CREATE_INSPECTION_FAILED:
			return {
				...state,
				createInspectionFail: true
			}
		case ActionType.CLOSE_CREATE_INSPECTION_SUCCESS_NOTIFICATION:
			return {
				...state,
				createInspectionSuccess: false,
			}
		case ActionType.CLOSE_CREATE_INSPECTION_FAIL_NOTIFICATION:
			return {
				...state,
				createInspectionFail: false,
			}
		case ActionType.DELETE_INSPECTION_SUCCESS:
			newInspections = [];
			_.forEach([...state.inspections], (inspection) => {
				if (inspection.ID !== action.inspectionId) {
					newInspections.push(inspection);
				}
			});
			return {
				...state,
				inspections: newInspections
			}
		case ActionType.GET_INSPECTION_PERFORMERS:
			return {
				...state,
				inspectionPerformers: Array.isArray(action.performers) ? action.performers : []
			}
		case ActionType.GET_CLIENTS:
			return {
				...state,
				clients: Array.isArray(action.clients) ? action.clients : []
			}
		case ActionType.GET_AGREEMENTS:
			return {
				...state,
				agreements: action.agreements ?? []
			}
		case ActionType.UPDATE_AGREEMENT_SUCCESS:
			newAgreements = [];
			_.forEach([...state.agreements], (agreement) => {
				if (agreement.systemId == action.agreement.systemId) {
					agreement = action.agreement;
				}
				newAgreements.push(agreement);
			});
			
			return {
				...state,
				agreements: newAgreements,
				updateAgreementSuccess: true
			}
		case ActionType.UPDATE_AGREEMENT_FAILED:
			return {
				...state,
				updateAgreementFail: true,
			}
		case ActionType.CLOSE_UPDATE_AGREEMENT_SUCCESS_NOTIFICATION:
			return {
				...state,
				updateAgreementSuccess: false,
			}
		case ActionType.CLOSE_UPDATE_AGREEMENT_FAIL_NOTIFICATION:
			return {
				...state,
				updateAgreementFail: false,
			}
		case ActionType.CREATE_AGREEMENT_SUCCESS:
			newAgreements = [...state.agreements];
			newAgreements.push(action.agreement);
			return {
				...state,
				agreements: newAgreements,
				createAgreementSuccess: true
			}
		case ActionType.CREATE_AGREEMENT_FAILED:
			return {
				...state,
				createAgreementFail: true
			}
		case ActionType.CLOSE_CREATE_AGREEMENT_SUCCESS_NOTIFICATION:
			return {
				...state,
				createAgreementSuccess: false,
			}
		case ActionType.CLOSE_CREATE_AGREEMENT_FAIL_NOTIFICATION:
			return {
				...state,
				createAgreementFail: false,
			}
		case ActionType.DELETE_AGREEMENT_SUCCESS:
			newAgreements = [];
			_.forEach([...state.agreements], (agreement) => {
				if (agreement.ID !== action.ID) {
					newAgreements.push(agreement);
				}
			});
			return {
				...state,
				agreements: newAgreements
			}
		case ActionType.GET_SERVICE_ACTIONS:
			return {
				...state,
				serviceActions: action.serviceActions ?? []
			}
		case ActionType.UPDATE_SERVICE_ACTION_SUCCESS:
			newServiceActions = [];
			_.forEach([...(state.serviceActions ?? [])], (serviceAction) => {
				if (serviceAction.ID == action.serviceAction.ID) {
					serviceAction = action.serviceAction;
				}
				newServiceActions.push(serviceAction);
			});
			newInspectionServiceActions = [];
			_.forEach([...(state.inspectionServiceActions ?? [])], (serviceAction) => {
				if (serviceAction.ID == action.serviceAction.ID) {
					serviceAction = action.serviceAction;
				}
				newInspectionServiceActions.push(serviceAction);
			});

			return {
				...state,
				serviceActions: newServiceActions,
				inspectionServiceActions: newInspectionServiceActions,
				updateServiceActionSuccess: true
			}
		case ActionType.UPDATE_SERVICE_ACTION_FAILED:
			return {
				...state,
				updateServiceActionFail: true,
			}
		case ActionType.CLOSE_UPDATE_SERVICE_ACTION_SUCCESS_NOTIFICATION:
			return {
				...state,
				updateServiceActionSuccess: false,
			}
		case ActionType.CLOSE_UPDATE_SERVICE_ACTION_FAIL_NOTIFICATION:
			return {
				...state,
				updateServiceActionFail: false,
			}
		case ActionType.CREATE_SERVICE_ACTION_SUCCESS:
			newServiceActions = [...(state.serviceActions ?? [])];
			newServiceActions.push(action.serviceAction);
			newInspectionServiceActions = [...(state.inspectionServiceActions ?? [])];
			if (action.serviceAction.inspectionId) {
				newInspectionServiceActions.push(action.serviceAction);
			}
			return {
				...state,
				serviceActions: newServiceActions,
				inspectionServiceActions: newInspectionServiceActions,
				createServiceActionSuccess: true
			}
		case ActionType.CREATE_SERVICE_ACTION_FAILED:
			return {
				...state,
				createServiceActionFail: true
			}
		case ActionType.CLOSE_CREATE_SERVICE_ACTION_SUCCESS_NOTIFICATION:
			return {
				...state,
				createServiceActionSuccess: false,
			}
		case ActionType.CLOSE_CREATE_SERVICE_ACTION_FAIL_NOTIFICATION:
			return {
				...state,
				createServiceActionFail: false,
			}
		case ActionType.DELETE_SERVICE_ACTION_SUCCESS:
			newServiceActions = [];
			_.forEach([...(state.serviceActions ?? [])], (serviceAction) => {
				if (serviceAction.ID !== action.serviceActionId) {
					newServiceActions.push(serviceAction);
				}
			});
			newInspectionServiceActions = [];
			_.forEach([...(state.inspectionServiceActions ?? [])], (serviceAction) => {
				if (serviceAction.ID !== action.serviceActionId) {
					newInspectionServiceActions.push(serviceAction);
				}
			});
			return {
				...state,
				serviceActions: newServiceActions,
				inspectionServiceActions: newInspectionServiceActions
			}
		case ActionType.GET_INSPECTION_SERVICE_ACTIONS:
			return {
				...state,
				inspectionServiceActions: action.serviceActions ?? []
			}
		case ActionType.GET_INSPECTION_SERVICE_ACTIONS_FAILED:
			return {
				...state,
				inspectionServiceActions: []
			}
		case ActionType.CLEAR_INSPECTION_SERVICE_ACTIONS:
			return {
				...state,
				inspectionServiceActions: []
			}
		case ActionType.GET_AUDIT_CHANGES_START:
			return {
				...state,
				auditChangesLoading: true
			}
		case ActionType.GET_AUDIT_CHANGES:
			return {
				...state,
				auditChanges: action.auditChanges ?? [],
				auditChangesLoading: false
			}
		case ActionType.GET_AUDIT_CHANGES_FAILED:
			return {
				...state,
				auditChanges: [],
				auditChangesLoading: false
			}
		case ActionType.GET_SERVICE_ACTION_ATTACHMENTS:
			return {
				...state,
				serviceActionAttachments: action.attachments ?? []
			}
		case ActionType.GET_SERVICE_ACTION_ATTACHMENTS_FAILED:
			return {
				...state,
				serviceActionAttachments: []
			}
		case ActionType.CLEAR_SERVICE_ACTION_ATTACHMENTS:
			return {
				...state,
				serviceActionAttachments: []
			}
		case ActionType.CREATE_SERVICE_ACTION_ATTACHMENT_SUCCESS:
			return {
				...state,
				serviceActionAttachments: [...(state.serviceActionAttachments ?? []), action.attachment]
			}
		case ActionType.CREATE_SERVICE_ACTION_ATTACHMENT_FAILED:
			return {
				...state,
				createServiceActionAttachmentFail: true
			}
		case ActionType.DELETE_SERVICE_ACTION_ATTACHMENT_SUCCESS:
			return {
				...state,
				serviceActionAttachments: (state.serviceActionAttachments ?? []).filter((att) => att.id !== action.attachmentId)
			}
		case ActionType.DELETE_SERVICE_ACTION_ATTACHMENT_FAILED:
			return {
				...state,
				deleteServiceActionAttachmentFail: true
			}
		case ActionType.GET_SERVICE_ACTION_PART_IMAGES:
			return {
				...state,
				serviceActionPartImages: action.images ?? []
			}
		case ActionType.GET_SERVICE_ACTION_PART_IMAGES_FAILED:
			return {
				...state,
				serviceActionPartImages: []
			}
		case ActionType.CLEAR_SERVICE_ACTION_PART_IMAGES:
			return {
				...state,
				serviceActionPartImages: []
			}
		case ActionType.CREATE_SERVICE_ACTION_PART_IMAGE_SUCCESS:
			return {
				...state,
				serviceActionPartImages: [...(state.serviceActionPartImages ?? []), action.image]
			}
		case ActionType.CREATE_SERVICE_ACTION_PART_IMAGE_FAILED:
			return {
				...state,
				createServiceActionPartImageFail: true
			}
		case ActionType.DELETE_SERVICE_ACTION_PART_IMAGE_SUCCESS:
			return {
				...state,
				serviceActionPartImages: (state.serviceActionPartImages ?? []).filter((img) => img.id !== action.imageId)
			}
		case ActionType.DELETE_SERVICE_ACTION_PART_IMAGE_FAILED:
			return {
				...state,
				deleteServiceActionPartImageFail: true
			}
		case ActionType.GET_SYSTEMS_VERY_SHORT:
			return {
				...state,
				systemsVeryShort: action.systems
			}
		case ActionType.CREATE_SYSTEM_GROUP:
			newSystemGroups = [...state.systemGroups]
			if (action.newID > 0) {
				newSystemGroups.push({ID: action.newID, name: action.name, public: action.public});
			}

			return {
				...state,
				systemGroups: newSystemGroups,
				disableSystemGroupSubmit: false,
				systemGroupSaveSuccessfully: action.newID > 0,
				systemGroupSaveFail: !(action.newID > 0)
			}
		case ActionType.DISABLE_SYSTEM_GROUP_SUBMIT:
			return {
				...state,
				disableSystemGroupSubmit: true
			}
		case ActionType.CLOSE_NOTIFICATION:
			return {
				...state,
				systemGroupSaveSuccessfully: false,
				systemGroupSaveFail: false
			};
		case ActionType.GET_SYSTEM_GROUPS:
			return {
				...state,
				systemGroups: action.systemGroups
			}
		case ActionType.GET_SYSTEMS_FOR_GROUP:
			return {
				...state,
				systemsForGroup: action.systems,
				groupId: action.groupId,
				forbidden: action.groupId && !action.systems?.length
			}
		case ActionType.ADD_SYSTEMS_TO_GROUP_SUCCEEDED:
			return {
				...state,
				addSystemsToGroupSucceeded: true,
				addSystemsToGroupFailed: false,
			};
		case ActionType.ADD_SYSTEMS_TO_GROUP_FAILED:
			return {
				...state,
				addSystemsToGroupSucceeded: false,
				addSystemsToGroupFailed: true,
			};
		case ActionType.CLOSE_ADD_SYSTEMS_TO_GROUP_NOTIFICATION:
			return {
				...state,
				addSystemsToGroupSucceeded: false,
				addSystemsToGroupFailed: false,
			};
		case ActionType.DELETE_SYSTEM_SUCCESSFULLY:
			newSystemsForGroup = [];
			newSystems = [];
			if (state.systemsForGroup?.length) {
				_.forEach([...state.systemsForGroup], (system) => {
					if (system.ID !== action.ID) {
						newSystemsForGroup.push(system);
					}
				});			
			}
			if (state.systems?.length) {
				_.forEach([...state.systems], (system) => {
					if (system.ID !== action.ID) {
						newSystems.push(system);
					}
				});			
			}
			return {
				...state,
				systemsForGroup: newSystemsForGroup,
				systems: newSystems,
				FreeSystems: newSystems
			};
		case ActionType.DELETE_ACCOUNT_SUCCEEDED:
			newAccounts = [];
			if (state.accounts?.length) {
				_.forEach([...state.accounts], (acc) => {
					if (acc.id !== action.id) {
						newAccounts.push(acc);
					}
				});			
			}
			return {
				...state,
				accounts: newAccounts,
			};
		case ActionType.ADD_ACCOUNTS_TO_SYSTEM_GROUP_SUCCEEDED:
			return {
				...state,
				addUsersToSystemGroupSucceeded: true,
				addUsersToSystemGroupFailed: false,
			};
		case ActionType.ADD_ACCOUNTS_TO_SYSTEM_GROUP_FAILED:
			return {
				...state,
				addUsersToSystemGroupSucceeded: false,
				addUsersToSystemGroupFailed: true,
			};
		case ActionType.CLOSE_ADD_ACCOUNTS_TO_SYSTEM_GROUP_NOTIFICATION:
			return {
				...state,
				addUsersToSystemGroupSucceeded: false,
				addUsersToSystemGroupFailed: false,
			};
		case ActionType.GET_ACCOUNTS_FOR_SYSTEM_GROUP:
			return {
				...state,
				accountsForGroup: action.accounts,
				groupId: action.groupId
			}
		case ActionType.SHOW_FILTERED_SYSTEM_NAMES_FOR_GROUP: {
			return {
				...state,
				dashboardFilteredSystemNamesForGroup: action.payload
			};
		}
		case ActionType.SET_RAINSTORM_MODE:
			updatedSystem = state.system;
			if (state.system?.ID == action.systemID) {
				updatedSystem.rainstormModeNow =  action.modeOn;
				updatedSystem.rainstormModeEnd =  action.modeOn ? {Time: action.rainstormModeEnd, Valid: true} : null;
				updatedSystem.w2ConfigurationUpdatedAt = action.w2ConfigurationUpdatedAt;
			}
			return {
				...state,
				rainstormModeSettingSuccess: action.success,
				rainstormModeSettingFailed: !action.success,
				rainstormModeSettingFailedReason: action.success ? null : action.reason,
				system: updatedSystem
			}
		case ActionType.CLOSE_SET_RAINSTORM_MODE_NOTIFICAION:
			return {
				...state,
				rainstormModeSettingSuccess: false,
				rainstormModeSettingFailed: false,
				rainstormModeSettingFailedReason: null
			}
		case ActionType.SET_SERVICE_MODE:
			updatedSystem = state.system;
			if (state.system?.ID == action.systemID) {
				updatedSystem.serviceModeNow =  action.modeOn;
				updatedSystem.serviceModeEnd =  action.modeOn ? action.serviceModeEnd : null;
			}
			return {
				...state,
				serviceModeSettingSuccess: action.success,
				serviceModeSettingFailed: !action.success,
				serviceModeSettingFailedReason: action.success ? null : action.reason,
				system: updatedSystem
			}
		case ActionType.CLOSE_SET_SERVICE_MODE_NOTIFICAION:
			return {
				...state,
				serviceModeSettingSuccess: false,
				serviceModeSettingFailed: false,
				serviceModeSettingFailedReason: null
			}
		case ActionType.RESET_SENSOR_ERROR_COUNTS:
			return {
				...state,
				resetSensorErrorCountsSuccess: action.success,
				resetSensorErrorCountsFailed: !action.success
			}
		case ActionType.CLOSE_RESET_SENSOR_ERROR_COUNTS_NOTIFICATION:
			return {
				...state,
				resetSensorErrorCountsSuccess: false,
				resetSensorErrorCountsFailed: false
			}
		case ActionType.EXPORT_FAILED_NO_DATA:
			return {
				...state,
				exportFailedNoData: true
			}
		case ActionType.EXPORT_FAILED:
			return {
				...state,
				exportFailed: true
			}
		case ActionType.CLOSE_EXPORT_NOTIFICATION:
			return {
				...state,
				exportFailedNoData: false,
				exportFailed: false,
				isFileExporting: false
			}
		case ActionType.SEND_TEST_NOTIFICATION:
			return {
				...state,
				testNotificationSuccess: action.success,
				testNotificationFailed: !action.success
			}
		case ActionType.CLOSE_SEND_TEST_NOTIFICATION_NOTIFICAION:
			return {
				...state,
				testNotificationSuccess: false,
				testNotificationFailed: false
			}

		case ActionType.GET_SIMCARDS:
			return {
				...state,
				simcards: action.simcards ?? []
			}
		case ActionType.GET_SIMCARD:
			return {
				...state,
				currentSimcard: action.currentSimcard
		}
		case ActionType.GET_SIMCARD_ASSIGNMENTS:
			return {
				...state,
				simcardAssignments: action.simcardAssignments ?? []
			}
		case ActionType.UPDATE_SIMCARD_SUCCESS:
			newSimcards = [];
			_.forEach([...state.simcards], (simcard) => {
				if (simcard.ID == action.simcard.ID) {
					simcard = action.simcard;
				}
				newSimcards.push(simcard);
			});
			
			return {
				...state,
				simcards: newSimcards,
				updateSimcardSuccess: true
			}
		case ActionType.UPDATE_SIMCARD_FAILED:
			return {
				...state,
				updateSimcardFail: true,
				updateSimcardFailMessage: action.message,
			}
		case ActionType.CLOSE_UPDATE_SIMCARD_SUCCESS_NOTIFICATION:
			return {
				...state,
				updateSimcardSuccess: false,
			}
		case ActionType.CLOSE_UPDATE_SIMCARD_FAIL_NOTIFICATION:
			return {
				...state,
				updateSimcardFail: false,
				updateSimcardFailMessage: null,
			}
		case ActionType.CREATE_SIMCARD_SUCCESS:
			newSimcards = [...state.simcards];
			newSimcards.push(action.simcard);
			return {
				...state,
				simcards: newSimcards,
				createSimcardSuccess: true
			}
		case ActionType.CREATE_SIMCARD_FAILED:
			return {
				...state,
				createSimcardFail: true,
				createSimcardFailMessage: action.message,
			}
		case ActionType.CLOSE_CREATE_SIMCARD_SUCCESS_NOTIFICATION:
			return {
				...state,
				createSimcardSuccess: false,
			}
		case ActionType.CLOSE_CREATE_SIMCARD_FAIL_NOTIFICATION:
			return {
				...state,
				createSimcardFail: false,
				createSimcardFailMessage: null,
			}
		case ActionType.DELETE_SIMCARD_SUCCESS:
			newSimcards = [];
			_.forEach([...state.simcards], (simcard) => {
				if (simcard.ID !== action.ID) {
					newSimcards.push(simcard);
				}
			});
			return {
				...state,
				simcards: newSimcards
			}
		case ActionType.GET_ROUTERS:
			return {
				...state,
				routers: action.routers ?? []
			}
		case ActionType.GET_ROUTER:
			return {
				...state,
				currentRouter: action.currentRouter
		}
		case ActionType.GET_FREE_SIMCARDS:
			return {
				...state,
				freeSimcards: action.simcards ?? []
			}
		case ActionType.UPDATE_ROUTER_SUCCESS:
			newRouters = [];
			_.forEach([...state.routers], (router) => {
				if (router.ID == action.router.ID) {
					router = action.router;
					router.updatedAt = action.data.updatedAt;
				}
				newRouters.push(router);
			});
			newSimcards = [];
			_.forEach([...state.simcards], (simcard) => {
				if (action.router.simcardId && simcard.ID == action.router.simcardId) {
					// newly (re)bound to this router
					simcard.systemId = action.router.systemId;
					simcard.systemName = action.router.systemName;
					simcard.nodeId = action.router.nodeId;
					simcard.nodeName = action.router.nodeName;
					simcard.routerId = action.router.ID;
					simcard.routerSerialNumber = action.router.serialNumber;
				} else if (action.router.previousSimcardId && simcard.ID == action.router.previousSimcardId) {
					// unbound from this router
					simcard.systemId = null;
					simcard.systemName = null;
					simcard.nodeId = null;
					simcard.nodeName = null;
					simcard.routerId = null;
					simcard.routerSerialNumber = null;
				}
				newSimcards.push(simcard);
			});

			return {
				...state,
				routers: newRouters,
				simcards: newSimcards,
				updateRouterSuccess: true
			}
		case ActionType.UPDATE_ROUTER_FAILED:
			return {
				...state,
				updateRouterFail: true,
			}
		case ActionType.CLOSE_UPDATE_ROUTER_SUCCESS_NOTIFICATION:
			return {
				...state,
				updateRouterSuccess: false,
			}
		case ActionType.CLOSE_UPDATE_ROUTER_FAIL_NOTIFICATION:
			return {
				...state,
				updateRouterFail: false,
			}
		case ActionType.CREATE_ROUTER_SUCCESS:
			newRouters = [...state.routers];
			newRouters.push(action.router);
			newSimcards = [];
			_.forEach([...state.simcards], (simcard) => {
				if (action.router.simcardId && simcard.ID == action.router.simcardId) {
					simcard.systemId = action.router.systemId;
					simcard.systemName = action.router.systemName;
					simcard.nodeId = action.router.nodeId;
					simcard.nodeName = action.router.nodeName;
					simcard.routerId = action.router.ID;
					simcard.routerSerialNumber = action.router.serialNumber;
				}
				newSimcards.push(simcard);
			});
			return {
				...state,
				routers: newRouters,
				simcards: newSimcards,
				createRouterSuccess: true
			}
		case ActionType.CREATE_ROUTER_FAILED:
			return {
				...state,
				createRouterFail: true
			}
		case ActionType.CLOSE_CREATE_ROUTER_SUCCESS_NOTIFICATION:
			return {
				...state,
				createRouterSuccess: false,
			}
		case ActionType.CLOSE_CREATE_ROUTER_FAIL_NOTIFICATION:
			return {
				...state,
				createRouterFail: false,
			}
		case ActionType.DELETE_ROUTER_SUCCESS:
			newRouters = [];
			_.forEach([...state.routers], (router) => {
				if (router.ID !== action.ID) {
					newRouters.push(router);
				}
			});
			newSimcards = [];
			_.forEach([...state.simcards], (simcard) => {
				if (action.simcardId && simcard.ID === action.simcardId) {
					simcard.routerId = null;
					simcard.routerSerialNumber = null;
					simcard.systemId = null;
					simcard.systemName = null;
					simcard.nodeId = null;
					simcard.nodeName = null;
				}
				newSimcards.push(simcard);
			});
			return {
				...state,
				routers: newRouters,
				simcards: newSimcards,
				// only the router's own SIM card (if it had one) becomes free again
				freeSimcards: action.simcardId
					? [...state.freeSimcards, {'ID': action.simcardId, 'ip': action.simcardName, 'telephone': null}]
					: state.freeSimcards
			}
		case ActionType.GET_SMSES:
			return {
				...state,
				smses: action.smses ?? [],
				smsesLoading: false
			}
		case ActionType.SMSES_LOADING:
			return {
				...state,
				smsesLoading: action.loading
			}
		case ActionType.SEND_SMS:
			let newSmses = {
				data: [action.sms, ...state.smses.data.slice(0, 99)], // prepend new SMS, keep first 99 old ones
				totalRecords: state.smses.totalRecords + 1
			};

			return {
				...state,
				smses: newSmses,
				createSmsSuccess: true,
				smsesLoading: false
			}
		case ActionType.GET_ROUTERS_WITH_SIMCARDS:
			return {
				...state,
				routersWithSimcards: action.routersWithSimcards ?? [],
			}
		case ActionType.GET_NODES_WITH_SIMCARDS:
			return {
				...state,
				nodesWithSimcards: action.nodesWithSimcards ?? [],
			}
		case ActionType.GET_SYSTEMS_FOR_TABLE_START:
			return {
				...state,
				systemsForTableLoading: true,
			};
		case ActionType.GET_SYSTEMS_FOR_TABLE:
			return {
				...state,
				systemsForTable: action.systems,
				systemsForTableLoading: false,
			};
		case ActionType.GET_SYSTEMS_FOR_TABLE_FAILED:
			return {
				...state,
				systemsForTableLoading: false,
			};
		case ActionType.CLEAR_SYSTEMS_FOR_TABLE:
			return {
				...state,
				systemsForTable: [],
				systemsForTableLoading: true,
			};
		case ActionType.GET_NODE_IMAGES:
			return {
				...state,
				nodeImages: action.nodeImages ?? [],
				currentNodeId: action.nodeId
			}
		case ActionType.CREATE_NODE_IMAGE_FAILED:
			return {
				...state,
				createNodeImageFailed: true,
				createNodeImageSuccess: false,
			}
		case ActionType.CREATE_NODE_IMAGE_SUCCESS:
			newNodeImages = [action.nodeImage, ...state.nodeImages];
			return {
				...state,
				createNodeImageFailed: false,
				createNodeImageSuccess: true,
				nodeImages: newNodeImages
			}
		case ActionType.DELETE_NODE_IMAGE_SUCCESS:
			newNodeImages = [];
			_.forEach([...state.nodeImages], (nodeImage) => {
				if (nodeImage.id !== action.ID) {
					newNodeImages.push(nodeImage);
				}
			});
			return {
				...state,
				deleteNodeImageFailed: false,
				deleteNodeImageSuccess: true,
				nodeImages: newNodeImages
			}
		case ActionType.DELETE_NODE_IMAGE_FAILED:
			return {
				...state,
				deleteNodeImageFailed: true,
				deleteNodeImageSuccess: false,
			}
		case ActionType.RESET_NODE_IMAGE_FLAGS:
			return {
				...state,
				deleteNodeImageFailed: false,
				deleteNodeImageSuccess: false,
				createNodeImageFailed: false,
				createNodeImageSuccess: false,
			}
		case ActionType.BIND_DEVICE_TO_NODE_SUCCESS: {
			const newFreeDevices = state.FreeDevices.filter(
				(d) => d.SerialString !== action.deviceSerial
			);
			return {
				...state,
				FreeDevices: newFreeDevices,
				bindDeviceSuccess: true,
				bindDeviceFail: false,
			};
		}
		case ActionType.BIND_DEVICE_TO_NODE_FAILED:
			return {
				...state,
				bindDeviceSuccess: false,
				bindDeviceFail: true,
			}
		case ActionType.CLOSE_BIND_DEVICE_NOTIFICATION:
			return {
				...state,
				bindDeviceSuccess: false,
				bindDeviceFail: false,
			}
		case ActionType.SET_SYSTEM_NOTIFICATIONS:
			system = state.system;
			if (action.success && system.ID === action.systemId) {
				system['notificationsEmailOn'] = action.notificationsEmailOn;
				system['notificationsPushOn'] = action.notificationsPushOn;
				system['notificationsSmsOn'] = action.notificationsSmsOn;
				system['updatedViaWebsiteAt'] = action.updatedViaWebsiteAt;
			}
			return {
				...state,
				system: system,
				settingNotificationsSuccess: action.success,
				settingNotificationsFailed: !action.success
			}
		case ActionType.CLOSE_SET_SYSTEM_NOTIFICATIONS_NOTIFICATION:
			return {
				...state,
				settingNotificationsSuccess: false,
				settingNotificationsFailed: false,
			}
		case ActionType.SET_SYSTEM_PROBLEMS_CONFIRMED:
			updatedSystems = [];
			_.forEach(state.systemsForTable, (sys) => {
				if (sys.id === action.systemId && action.succeeded) {
					sys['problemsConfirmedUntil'] = action.confirmedUntil;
				}
				updatedSystems.push(sys);
			});
			return {
				...state,
				systemsForTable: updatedSystems
			}
		default:
			return state;
	}
};

export default dashboardReducer;
